import { AGENT_PORTAL_URL, AGENT_SERVER_URL, API_URL, APP_LIVE_URL, APP_URL, COMPANY_NAME, THEME_COLOR, THEME_TEXT_COLOR, columnsServices, dateString } from "../../../config/config";
import { getSingleClientMetabseReport, addClientMetabseReport } from "./../../../config/metabase_api_calls";
import { listClients } from "./../../../config/api_calls";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import dateFormat, { masks } from "dateformat";
import * as XLSX from "xlsx";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { addSettings } from "../../../actions";
import { Link } from "react-router-dom";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import HomeIcon from "@material-ui/icons/Home";
import TextField from "../../../components/InputFields/TextField";
import MutextField from "@material-ui/core/TextField";
import DataTable from "../../../components/Tables/DataTableReports";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { encryptValue, parseAndDecryptFromState } from "../../../components/Encryption/cryptoUtils";

const extendedMoment = extendMoment(moment);

const animatedComponents = makeAnimated();
const Select2 = Select;

const auth = new HelperClass();

class Reports extends Component {
  constructor() {
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();

    var datestring = new Date().toISOString().slice(0, 10);

    super();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    const today = extendedMoment();
    const monthAgo = moment().subtract(7, "day");
    this.state = {
      tableData: [],
      tableLoader: false,
      //start_date: monthAgo.format("YYYY-MM-DD"),
      //end_date: today.format("YYYY-MM-DD"),
      disabled: false,
      errorMessage: "",
      errorMessageTitle: "",
      successMessage: "",
      docErrorMessage: "",
      title: "",
      start_date: monthAgo.format("MM-DD-yyyy"),
      end_date: today.format("MM-DD-yyyy"),
      value: moment.range(monthAgo, today),
      description: "",
      report_params: "",
      report_url_id: "",
      add_picture: "",
      report_id: "",
      publish_report: "No",
      added_file: [],
      isEditorReady: false,
      add_pictures: [],
      add_picture_names: [],

      is_encrypted: "No",
      copied: false,
      extra_params: "",
      extra_params_array: [{}],
      extra_params_title: "",
      jumpErrorTitle: "",
      jumpError: "",

      isLocked: false,
      clientsList: [],
      selectedClients: [],
      selectAll: false,
      maxChars: 1000,
    };
  }

  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.listClients();
    this.setState({ isEditorReady: true });
    this.makeURLString();
  }

  listClients = async () => {
    const listAgentsResponce = await listClients(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("listClientsResponce: ", listAgentsResponce.data.data);
    if (
      listAgentsResponce.data.status === 403 ||
      listAgentsResponce.data.errors === "authentication missing" ||
      listAgentsResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentsResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentsResponce.data.status === 200 &&
      listAgentsResponce.data.message === "success"
    ) {
      let agents = listAgentsResponce.data.data
        .filter((agent) => agent[7] === "active")
        .map((agent) => ({
          value: agent[0],
          label: agent[1] + " (" + agent[4] + ")",
        }));
      //console.log("agentsList agents: ", agents);
      /*this.setState({
        clientsList: agents,
        selectedClients: agents,
      });*/
      this.setState({
        clientsList: agents,
        selectedClients: [],
      });
    } else {
      // window.location.replace("/error");
    }
  };

  handleSelectChange = (selectedOptions) => {
    if (!this.state.isLocked) {
      this.setState({ selectedClients: selectedOptions }, () => {
        let temp = false;
        if (
          this.state.clientsList.length === this.state.selectedClients.length
        ) {
          temp = true;
        }
        this.setState({ selectAll: temp });
      });
    }
  };

  handleSelectAllChange = () => {
    if (!this.state.isLocked) {
      const { clientsList, selectAll } = this.state;
      if (!selectAll) {
        this.setState({
          selectedClients: clientsList,
          selectAll: true,
        });
      } else {
        this.setState({
          selectedClients: [],
          selectAll: false,
        });
      }
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("MM-DD-YYYY"),
      end_date: value.end.format("MM-DD-YYYY"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({ [name]: value }, () => {
      if (name === "report_url_id" || name === "report_params") {
        this.makeURLString(); // state is now up-to-date
      }
    });
  };

  handleChangeTextarea = (event) => {
    const input = event.target.value;

    // Limit to 1000 characters
    if (input.length <= 1000) {
      this.setState({ description: input });
    }
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ description: updatedContent });
  };

  handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

    if (!selectedFiles.length) return; // No files selected

    // File type validation
    const allowedFileTypes = [".txt", ".pdf", ".csv", ".xlsx", ".xls", ".zip"];
    const invalidFiles = selectedFiles.filter(
      (file) =>
        !allowedFileTypes.includes(
          `.${file.name.split(".").pop().toLowerCase()}`
        )
    );

    if (invalidFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Invalid file type detected. Please select valid files.",
      });
      return;
    }

    // File size validation (50MB max per file)
    const maxSizeBytes = 50 * 1024 * 1024;
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > maxSizeBytes
    );

    if (oversizedFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Some files exceed the 50MB limit. Choose smaller files.",
      });
      return;
    }

    // Debugging output to ensure files are being processed correctly
    // console.log("Selected Files: ", selectedFiles);
    // console.log("Current add_pictures in state: ", this.state.add_pictures);

    // Append new files to existing array
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures, ...selectedFiles];
      // console.log("Updated Pictures: ", updatedPictures);
      // **Limit total files to 5**
      if (updatedPictures.length > 5) {
        return {
          docErrorMessage: "You can upload a maximum of 5 files.",
        };
      }
      return {
        add_pictures: updatedPictures,
        docErrorMessage: "", // Clear error message
        add_picture_names: updatedPictures.map((file) => file.name),
      };
    });
  };

  handleChangesEnc = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    const hasEnc = value.includes("enc=");
    let is_encrypted = "No";
    if (hasEnc) {
      is_encrypted = "Yes";
    }
    this.setState({
      [name]: value,
      is_encrypted: is_encrypted,
    });
  };

  handleRemoveSpecificRow = (idx) => () => {
    const extra_params_array = [...this.state.extra_params_array];
    extra_params_array.splice(idx, 1);
    this.setState({ extra_params_array });
  };

  addParams = () => {
    const { extra_params, extra_params_title } = this.state;
    this.setState({
      jumpErrorTitle: "",
      jumpError: "",
    });
    if (extra_params !== "" && extra_params_title !== "") {
      const hasEnc = extra_params.includes("enc=");
      if (hasEnc) {
        let newParam = {
          title: extra_params_title,
          parameter: extra_params,
        };
        this.setState((prevState) => ({
          extra_params_array: [...prevState.extra_params_array, newParam],
          extra_params_title: "",
        }));
        this.decrypt_parameters();
      } else {
        this.setState({
          //errorMessageTitle: "Encryption Missing",
          jumpError: "Please encrypt the parameters to proceed.",
        });

        //return false;
        setTimeout(() => {
          this.setState({ jumpErrorTitle: "", jumpError: "" });
        }, 4000);
      }
    } else {
      this.setState({
        //errorMessageTitle: "Missing parameter title or parameters.",
        jumpError: "Please enter the parameter title and parameters.",
      });

      setTimeout(() => {
        this.setState({ jumpErrorTitle: "", jumpError: "" });
      }, 4000);
    }
    //console.log("extra_params_array: ", this.state.extra_params_array);
  };

  encrypt_parameters = () => {
    const { extra_params } = this.state;

    if (extra_params && extra_params !== "") {
      // Remove leading '?' if present
      const cleanParams = extra_params.startsWith("?")
        ? extra_params.substring(1)
        : extra_params;

      // Encrypt the full query string
      const encrypted = encryptValue(cleanParams);

      // Set new URL with only ?enc=...
      const finalUrl = `?enc=${encrypted}`;

      this.setState({ extra_params: finalUrl, is_encrypted: "Yes" });
    } else {
      this.setState({ jumpError: "Please enter the parameters to encrypt." });
      setTimeout(() => {
        this.setState({ jumpErrorTitle: "", jumpError: "" });
      }, 4000);
    }
  };

  decrypt_parameters = () => {
    const { extra_params } = this.state;
    const parsedParams = parseAndDecryptFromState(extra_params);
    if (parsedParams) {
      this.setState({ extra_params: parsedParams, is_encrypted: "No" });
      // console.log("Decrypted & Parsed Params:", parsedParams);
      // Example: { dash_id: "234", date_filter: "2025-06-16", company_name: "ABC Company" }
    } else {
      console.warn("Invalid or incomplete query string.");
    }
  };

  fieldValidationUsername = () => {
    let { title, description } = this.state;

    if (title === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Title is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (description === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Description is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessageTitle: "",
        errorMessage: "",
        disabled: true,
      });
    }
    return true;
  };

  submitRequest = async (e) => {
    e.preventDefault();
    let {
      title,
      description,
      start_date,
      end_date,
      add_picture,
      add_picture_name,
      report_id,
      added_file,
      add_pictures,
      report_params,
      report_url_id,
      publish_report,
      extra_params_array,
      selectedClients,
    } = this.state;

    this.setState({
      verifyPasswordButton: true,
      disabled: true,
      errorMessageTitle: "",
      errorMessage: "",
    });
    // console.log("selectedClients: ", selectedClients);
    if (this.fieldValidationUsername() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("report_params", report_params);
      formData.append("report_url_id", report_url_id);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);
      formData.append("report_id", report_id);
      formData.append("publish_report", publish_report);
      formData.append("extra_params", JSON.stringify(extra_params_array));
      formData.append("selectedClients", JSON.stringify(selectedClients));
      formData.append("added_file", JSON.stringify(added_file));
      formData.append("user_type", auth.getUserType());
      formData.append("user_accountno", auth.getSubUserAccount());
      add_pictures.forEach((file) => {
        formData.append("files", file);
      });
      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "metabase_external/add_client_report_request_admin",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {}
          )
          .then((response) => {
            // console.log("response: ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                errorMessageTitle: "Missing Client",
                errorMessage: "Client does not found.",
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (response.data.status === 403) {
              this.setState({
                errorMessage: response.data.message,
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessage: "Your request has been updated successfully.",
                errorMessage: "",
                final_login_url: response.data.login_url,
                showLoginButton: true,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                window.location.replace("/metabaseReports");
              }, 3000);

              //this.nextStep();
            } else {
              this.setState({
                errorMessageTitle: "System Error",
                errorMessage: "There is some error while updated the request.",
                disabled: false,
                successMessage: "",
                submitRfq_button_loader: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            }
            this.setState({
              submitRfq_button_loader: false,
            });
          });
      } catch (error) {
        this.setState({
          errorMessageTitle: "System Error",
          errorMessage: "There is some error while updated the request.",
          disabled: false,
          successMessage: "",
          submitRfq_button_loader: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 4000);
      }
    }
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures];
      const updatedNames = [...prevState.add_picture_names];

      // Remove file from both arrays by index
      updatedPictures.splice(index, 1);
      updatedNames.splice(index, 1);

      return {
        add_pictures: updatedPictures,
        add_picture_names: updatedNames,
      };
    });
  };

  handleRemoveAddedFile = (index) => {
    // console.log("handleRemoveAddedFile: ", this.state.added_file);
    this.setState((prevState) => {
      const updatedNames = [...prevState.added_file];

      // Remove file from both arrays by index

      updatedNames.splice(index, 1);
      // console.log("handleRemoveAddedFileAfter: ", updatedNames);
      return {
        added_file: updatedNames,
      };
    });
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    var url = APP_LIVE_URL + "files_data/pages/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  makeURLString = () => {
    const { report_url_id } = this.state;
    let { report_params } = this.state;

    // Parse if it's a string
    if (typeof report_params === "string") {
      try {
        report_params = JSON.parse(report_params);
      } catch (e) {
        console.error("Failed to parse report_params JSON:", e);
        report_params = {};
      }
    }

    const queryParams = [`dash_id=${encodeURIComponent(report_url_id)}`];

    if (report_params && typeof report_params === "object") {
      for (let key in report_params) {
        if (!report_params.hasOwnProperty(key)) continue;

        let value = report_params[key];
        if (Array.isArray(value)) value = value[0];

        if (value !== undefined && value !== null && value !== "") {
          queryParams.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          );
        }
      }
    }

    const finalQueryString = `?${queryParams.join("&")}`;
    // console.log("FINAL QUERY STRING:", finalQueryString);
    this.setState({ extra_params: finalQueryString });
  };

  render() {
    //  let tableTitle = this.props.props.match.params.api_url.replaceAll("_", " ");
    const Theme = {
      palette: {
        primary: {
          contrastText: "#FFFFFF",
          dark: "#000000",
          main: "#000000",
          light: "#000000",
        },
      },
    };
    const {
      isOpen,
      value,
      start_date,
      end_date,
      clientsList,
      selectAll,
      selectedClients,
      isLocked,
      description,
      maxChars,
    } = this.state;
    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const options = {
      selectableRows: "multiple", // Enable checkboxes for row selection
    };
    const remaining = maxChars - description.length;
    return (
      <div className="nk-content " id="Support_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>

                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/metabaseReports")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Client Reports
                      </Link>
                      <Typography color="textPrimary" className="">
                        Add Request
                      </Typography>
                    </Breadcrumbs>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-4">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <form
                              method="post"
                              className="pageForm"
                              onSubmit={this.submitRequest}
                            autoComplete="off"
                            role="presentation"
                            >
                              <div className="row g-4">
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label className="form-label" for="title">
                                      Title <sup>*</sup>
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control form-control-lg"
                                        id="title"
                                        name="title"
                                        value={this.state.title}
                                        onChange={this.handleChanges}
                                        placeholder=""
                                      autoComplete="new-password" />
                                      <small>
                                        Enter descriptive title for your report
                                        request.
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div onClick={this.onToggle} className="">
                                      <TextField
                                        label="Date and Time"
                                        variant="outlined"
                                        fullWidth
                                        value={formattedDateRange}
                                        InputProps={{
                                          onClick: this.onToggle,
                                        }}
                                        placeholder="Select Date Range"
                                      autoComplete="new-password"
                                      />
                                      {/*<small>
                                        Select date and time for data range you
                                        want to include in the report.
                                      </small>*/}
                                    </div>
                                  </div>
                                  {isOpen && (
                                    <div
                                      className="fixed inset-0"
                                      style={{
                                        zIndex: 1000,
                                        position: "absolute",
                                        marginTop: "-20px",
                                      }}
                                    >
                                      <div
                                        className="absolute inset-0"
                                        onClick={this.onToggle}
                                      ></div>
                                      <div
                                        className="absolute top-40 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-lg p-4"
                                        style={{ zIndex: 1001 }}
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            cursor: "pointer",
                                            zIndex: 1002,
                                          }}
                                          onClick={this.onToggle}
                                        >
                                          <em className="icon ni ni-cross"></em>
                                        </div>
                                        <DateRangePicker
                                          value={value}
                                          onSelect={this.onSelect}
                                          singleDateRange={true}
                                          numberOfCalendars={2}
                                          showLegend={true}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label className="form-label" for="title">
                                      Report ID
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control form-control-lg"
                                        id="report_url_id"
                                        name="report_url_id"
                                        value={this.state.report_url_id}
                                        onChange={this.handleChanges}
                                        placeholder=""
                                      autoComplete="new-password" />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <label className="form-label" for="title">
                                      Params
                                    </label>
                                    <div className="form-control-wrap">
                                      <input
                                        type="text"
                                        className="form-control form-control-lg"
                                        id="report_params"
                                        name="report_params"
                                        value={this.state.report_params}
                                        onChange={this.handleChanges}
                                        placeholder=""
                                      autoComplete="new-password" />
                                      <small>
                                        <sup>*</sup>Sample Params string should
                                        be like this and this should be locked
                                        in Metabase interface
                                        <br />
                                        {`{ "COLUMN_NAME_1": VALUE, "COLUMN_NAME_2": VALUE }`}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-lg-6"
                                  style={{ marginTop: "52px" }}
                                >
                                  <div className="form-group">
                                    <MutextField
                                      id="publish_report"
                                      name="publish_report"
                                      select
                                      label="Publish Report"
                                      value={this.state.publish_report}
                                      onChange={this.handleChanges}
                                      SelectProps={{
                                        native: true,
                                      }}
                                      helperText="The report will be displayed only if it is published."
                                      variant="outlined"
                                      fullWidth
                                    autoComplete="new-password"
                                    >
                                      <option key="0" value="No">
                                        No
                                      </option>
                                      <option key="1" value="Yes">
                                        Yes
                                      </option>
                                    </MutextField>
                                  </div>
                                </div>
                                {clientsList && clientsList.length > 0 ? (
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              checked={selectAll}
                                              onChange={
                                                this.handleSelectAllChange
                                              }
                                              name="selectAll"
                                              disabled={isLocked}
                                            />
                                          }
                                          label="Select all Clients"
                                          style={{
                                            width: "max-content",
                                            marginBottom: "10px",
                                            float: "right",
                                          }}
                                        />
                                      </div>
                                      <Select2
                                        id="selectedClients"
                                        value={selectedClients}
                                        isMulti
                                        name="clients"
                                        options={clientsList}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        isDisabled={isLocked}
                                        onChange={this.handleSelectChange}
                                        styles={{
                                          menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          control: (provided) => ({
                                            ...provided,
                                            minHeight: "55px", // Set desired height
                                          }),
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                <div
                                  className="col-lg-12"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <h6
                                    style={{ margin: 0, marginRight: "10px" }}
                                  >
                                    Extra Jump Parameters <sup></sup>
                                  </h6>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <table
                                      className="table table-bordered"
                                      id="tab_logic"
                                    >
                                      <thead className="thead-light">
                                        <tr>
                                          <th
                                            className="text-left"
                                            style={{ lineHeight: "28px" }}
                                          >
                                            {" "}
                                            Parameter Title{" "}
                                          </th>
                                          <th
                                            className="text-left"
                                            style={{ lineHeight: "28px" }}
                                          >
                                            {" "}
                                            Parameters{" "}
                                            <small>
                                              <sup>*</sup>i.e
                                              ?dash_id=123&date_filter=2025-06-16&company_name=ABC%20Company)
                                            </small>
                                          </th>

                                          <th className="text-center">
                                            &nbsp;
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              paddingTop: "20px",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              className="form-control form-control-lg"
                                              id="extra_params_title"
                                              name="extra_params_title"
                                              value={
                                                this.state.extra_params_title
                                              }
                                              onChange={this.handleChanges}
                                              maxLength={64}
                                              placeholder=""
                                            autoComplete="new-password" />
                                          </td>

                                          <td
                                            style={{
                                              paddingTop: "20px",
                                              width: "60%",
                                            }}
                                          >
                                            <input
                                              type="text"
                                              className="form-control form-control-lg"
                                              id="extra_params"
                                              name="extra_params"
                                              value={this.state.extra_params}
                                              onChange={this.handleChangesEnc}
                                              placeholder=""
                                            autoComplete="new-password" />
                                            <div className="nk-block-between-md">
                                              <div className="nk-block-head-content">
                                                <label
                                                  for="extra_params"
                                                  style={{
                                                    color: "#344357",
                                                    fontWeight: "500",
                                                    marginBottom: "8px",
                                                  }}
                                                >
                                                  &nbsp;
                                                </label>
                                              </div>
                                              <div className="nk-block-head-content">
                                                <ul className="nk-block-tools gx-3">
                                                  <li>
                                                    {this.state.is_encrypted ===
                                                    "Yes" ? (
                                                      <a
                                                        className="text-primary fs-11"
                                                        onClick={() =>
                                                          this.decrypt_parameters()
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          fontWeight: "500",
                                                        }}
                                                      >
                                                        Decrypt
                                                      </a>
                                                    ) : null}
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            className="text-center"
                                            style={{
                                              paddingTop: "20px",
                                            }}
                                          >
                                            {this.state.is_encrypted ===
                                            "No" ? (
                                              <button
                                                type="button"
                                                className="btn btn-warning"
                                                onClick={() =>
                                                  this.encrypt_parameters()
                                                }
                                              >
                                                <em className="icon ni ni-security"></em>{" "}
                                                <span>Encrypt</span>
                                              </button>
                                            ) : this.state.is_encrypted ===
                                              "Yes" ? (
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => this.addParams()}
                                              >
                                                <em className="icon ni ni-plus-round"></em>{" "}
                                                <span>Add</span>
                                              </button>
                                            ) : null}
                                          </td>
                                        </tr>
                                        {this.state.jumpError &&
                                        this.state.jumpError !== "" ? (
                                          <tr>
                                            <td colSpan={3}>
                                              <span className="text-danger">
                                                {this.state.jumpError}
                                              </span>
                                            </td>
                                          </tr>
                                        ) : null}
                                        {this.state.extra_params_array &&
                                        this.state.extra_params_array.length >
                                          0 ? (
                                          <>
                                            {this.state.extra_params_array
                                              .filter(
                                                (item) =>
                                                  item.title || item.parameter
                                              )
                                              .map((item, idx) => (
                                                <tr key={`id-${idx}`}>
                                                  <td>{item.title}</td>
                                                  <td
                                                    className="text-primary"
                                                    style={{
                                                      overflowWrap: "anywhere",
                                                    }}
                                                  >
                                                    <small>{`${AGENT_PORTAL_URL}client/viewClientAnalytics/${item.parameter}`}</small>
                                                  </td>
                                                  <td className="text-center">
                                                    <CopyToClipboard
                                                      text={`${AGENT_PORTAL_URL}client/viewClientAnalytics/${item.parameter}`}
                                                      onCopy={() =>
                                                        this.setState({
                                                          copied: idx,
                                                        })
                                                      }
                                                    >
                                                      <button
                                                        className="btn btn-success btn-sm"
                                                        type="button"
                                                      >
                                                        <em className="icon ni ni-copy"></em>{" "}
                                                        Copy{" "}
                                                        {this.state.copied ===
                                                        idx ? (
                                                          <span
                                                            style={{
                                                              color: "white",
                                                              marginLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            <em className="icon ni ni-done"></em>
                                                          </span>
                                                        ) : null}
                                                      </button>
                                                    </CopyToClipboard>
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={this.handleRemoveSpecificRow(
                                                        idx
                                                      )}
                                                    >
                                                      <span
                                                        className="badge badge-outline-danger"
                                                        style={{
                                                          cursor: "pointer",
                                                          paddingTop: "3px",
                                                          paddingBottom: "3px",
                                                          paddingLeft: "7px",
                                                          fontSize: "18px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <em className="icon ni ni-trash"></em>
                                                      </span>
                                                    </a>
                                                  </td>
                                                </tr>
                                              ))}
                                          </>
                                        ) : null}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <div
                                  className="col-lg-12"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <h6
                                    style={{ margin: 0, marginRight: "10px" }}
                                  >
                                    Description <sup>*</sup>
                                  </h6>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <TextareaAutosize
                                        maxrows={10}
                                        name="description"
                                        id="description"
                                        aria-label=""
                                        placeholder=""
                                        //inputProps={{ maxLength: 1000 }}
                                        //maxLength={500}
                                        value={this.state.description}
                                        helperText="Maximum 1000 characters"
                                        onChange={this.handleChangeTextarea}
                                        style={{
                                          width: "100%",
                                          minHeight: "150px",
                                          borderColor: "rgba(0, 0, 0, 0.125)",
                                          borderRadius: "4px",
                                          padding: "5px",
                                        }}
                                        variant="outlined"
                                      />
                                      <div className="form-note">
                                        {remaining} characters remaining
                                      </div>
                                    </div>
                                    {this.state.isEditorReady ? (
                                      <>
                                        {/*<RichTextEditorComponent
                                          agreementContent={
                                            this.state.description
                                          }
                                          onContentChange={
                                            this.handleEditorChange
                                          }
                                        />*/}
                                      </>
                                    ) : null}
                                  </div>
                                </div>

                                <div className="col-lg-12 mt-4">
                                  <div className="nk-block-head">
                                    <div className="nk-block-head-content">
                                      <h5 className="nk-block-title title">
                                        Other Attachment{" "}
                                        <Tooltip
                                          title="Any other supporting attachments"
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>
                                      </h5>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div
                                      className="form-control-group"
                                      id="fileContainer"
                                    >
                                      <input
                                        type="file"
                                        id="add_picture"
                                        className="file-block"
                                        name="add_picture"
                                        defaultValue={this.state.add_picture}
                                        accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv"
                                        onChange={this.handleFileChange}
                                      autoComplete="new-password" />
                                    </div>
                                    <p
                                      style={{
                                        fontSize: "0.8rem",
                                        margin: "5px 0 0 3px",
                                      }}
                                    >
                                      Any other supporting attachments.
                                      <br />
                                      Supported file formats include: PDF, CSV,
                                      ZIP, TXT.
                                    </p>
                                    <p
                                      style={{
                                        fontSize: "0.8rem",
                                        margin: "2px 0 0 3px",
                                      }}
                                    >
                                      Maximum file size allowed: 50MB.
                                    </p>
                                    {this.state.add_picture_names.length >
                                      0 && (
                                      <ul style={{ marginLeft: "30px" }}>
                                        {this.state.add_picture_names.map(
                                          (name, index) => (
                                            <li
                                              className="text-primary"
                                              style={{ listStyle: "disc" }}
                                              key={index}
                                            >
                                              {name}{" "}
                                              <a
                                                onClick={() =>
                                                  this.handleRemoveFile(index)
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  marginLeft: "10px",
                                                  fontSize: "16px",
                                                }}
                                                className="text-danger"
                                              >
                                                <em className="icon ni ni-trash"></em>
                                              </a>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    )}
                                    {this.state.added_file &&
                                    this.state.added_file.length > 0 ? (
                                      <>
                                        {this.state.added_file.map(
                                          (item, index) => (
                                            <div key={index}>
                                              {item.added_file.map(
                                                (file, fileIndex) => (
                                                  <div
                                                    className="text-primary"
                                                    key={fileIndex}
                                                  >
                                                    <Tooltip title="View / Download file">
                                                      <a
                                                        onClick={() =>
                                                          this.downloadPdf(file)
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          marginLeft: "10px",
                                                        }}
                                                        className="text-primary"
                                                      >
                                                        {index + 1}. {file}{" "}
                                                      </a>
                                                    </Tooltip>
                                                    <Tooltip title="Delete File. Please click `Submit` after deleting this file.">
                                                      <a
                                                        onClick={() =>
                                                          this.handleRemoveAddedFile(
                                                            index
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          marginLeft: "10px",
                                                          fontSize: "16px",
                                                          color: "red",
                                                        }}
                                                        className="text-danger"
                                                      >
                                                        <em className="icon ni ni-trash"></em>
                                                      </a>
                                                    </Tooltip>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          )
                                        )}
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                                {this.state.docErrorMessage !== "" ? (
                                  <div className="col-lg-12">
                                    <div
                                      className="example-alert example-alert-revoke mt-3 mb-3"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p>{this.state.docErrorMessage}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="col-lg-12">
                                  <div className="form-group text-right">
                                    <button
                                      type="submit"
                                      className="btn btn-lg btn-primary"
                                      disabled={this.state.disabled}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          )}
                        </div>
                      </div>
                      {/* END TABLE */}
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Reports);
